export const studentConstants = {
  STUDENT_LOGIN_REQUEST: "STUDENT_LOGIN_REQUEST",
  STUDENT_LOGIN_SUCCESS: " STUDENT_LOGIN_SUCCESS",
  STUDENT_LOGIN_FAILURE: "STUDENT_LOGIN_FAILURE",
  STUDENT_LOGOUT: "STUDENT_LOGOUT",
  GET_STUDENT_DETAILS: "GET_STUDENT_DETAILS"
};
